<template>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Application Acknowledgment - {{ applicationData.application_number }}</title>
    <link rel="shortcut icon" href="images/favicon.png" type="image/x-icon">
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap" rel="stylesheet">
  </head>

  <body style="padding: 0px; margin: 0px; font-family: 'Montserrat', sans-serif; background-color: #a2a2a21c; box-sizing: border-box;">

  <!-- Loading State -->
  <div v-if="loading" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
    <div style="text-align: center;">
      <div style="border: 4px solid #f3f3f3; border-top: 4px solid #0045a1; border-radius: 50%; width: 50px; height: 50px; animation: spin 1s linear infinite; margin: 0 auto;"></div>
      <p style="margin-top: 20px; color: #666;">Loading application details...</p>
    </div>
  </div>

  <!-- Error State -->
  <div v-else-if="error" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
    <div style="text-align: center; padding: 40px; background: white; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
      <div style="font-size: 48px; color: #dc3545;">⚠️</div>
      <h2 style="color: #dc3545; margin: 20px 0 10px;">Error Loading Application</h2>
      <p style="color: #666;">{{ error }}</p>
      <button @click="goBack" style="margin-top: 20px; padding: 10px 30px; background: #0045a1; color: white; border: none; border-radius: 5px; cursor: pointer;">Go Back</button>
    </div>
  </div>

  <!-- Main Content -->
  <div v-else>
    <button class="print-btn" onclick="window.print()">
      <img src="assets/printer.svg" alt="Print">
    </button>

    <page class="page" style="width: 210mm; height: 297mm; display: flex; position: relative; flex-flow: column; background-color: white; margin: auto; overflow: hidden;">

      <!-- Main Content -->
      <div style="padding: 8mm 10mm; flex: 1; display: flex; flex-direction: column;">

        <!-- Header -->
        <header style="display: flex; height: auto; align-items: center; position: relative; width: 100%; justify-content: space-between; padding-bottom: 2mm;">
          <div>
            <img :src="state_logo()" style="height: 24mm; margin-right: 0mm;">
          </div>
          <div style="text-align: center; margin-right: 8mm; margin-left: 8mm;">
            <h2 style="margin-top: 0px; font-size: 18px; text-transform: uppercase; color: #4ca82c; font-weight: 700; margin-bottom: 1mm; padding-bottom: 0px;">
              County Government Of {{ county.countyName }}
            </h2>
            <h5 style="padding: 0px; margin: 0px; font-size: 11px; font-weight: bold; text-transform: uppercase; margin-bottom: 1mm;">
              Department of Lands, Housing & Urban Planning
            </h5>
            <h4 style="padding: 0px; margin: 0px; font-size: 9px; font-weight: 400;">
              {{ county.address }} | Email: {{ county.email }}
            </h4>
          </div>
          <div>
            <img :src="county_logo()" style="height: 24mm; margin-right: 0mm;">
          </div>
        </header>

        <!-- Blue Line -->
        <div style="margin: 2mm 0;">
          <img src="assets/blue-line.png" style="width: 100%;">
        </div>

        <!-- Document Title -->
        <div style="text-align: center; margin: 4mm 0; padding: 4mm; background: linear-gradient(135deg, #0045a1 0%, #003380 100%); border-radius: 2mm;">
          <h1 style="margin: 0; padding: 0; color: white; font-size: 16px; text-transform: uppercase; letter-spacing: 1.5px;">
            e-Construction Application Acknowledgment
          </h1>
          <p style="margin: 2mm 0 0 0; padding: 0; color: rgba(255,255,255,0.8); font-size: 10px;">
            Development Control & Improvement Application
          </p>
          <span v-if="!applicationData.isPaid" style="display: inline-block; margin-top: 3mm; background: #dc3545; color: white; padding: 1.5mm 6mm; border-radius: 1mm; font-size: 10px; font-weight: 700;">
            UNPAID - PAYMENT REQUIRED
          </span>
          <span v-else style="display: inline-block; margin-top: 3mm; background: #28a745; color: white; padding: 1.5mm 6mm; border-radius: 1mm; font-size: 10px; font-weight: 700;">
            PAID
          </span>
        </div>

        <!-- Application Number Box -->
        <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 4mm; padding: 3mm; background: #f8f9fa; border-radius: 2mm;">
          <div style="flex: 1;">
            <table style="font-size: 11px; border-collapse: collapse;">
              <tr>
                <td style="padding: 1.5mm 0; color: #666;">Application Number:</td>
                <td style="padding: 1.5mm 0 1.5mm 3mm; font-weight: 700; font-size: 14px; color: #0045a1;">{{ applicationData.application_number }}</td>
              </tr>
              <tr>
                <td style="padding: 1.5mm 0; color: #666;">Date Submitted:</td>
                <td style="padding: 1.5mm 0 1.5mm 3mm; font-weight: 600;">{{ formatDate(applicationData.created_at) }}</td>
              </tr>
              <tr>
                <td style="padding: 1.5mm 0; color: #666;">Status:</td>
                <td style="padding: 1.5mm 0 1.5mm 3mm;">
                  <span :style="getStatusStyle(applicationData.status)">{{ (applicationData.status || 'PENDING').toUpperCase() }}</span>
                </td>
              </tr>
            </table>
          </div>
          <div style="height: 22mm; width: 22mm; min-width: 22mm; border: 2px solid #0045a1; display: flex; justify-content: center; align-items: center; background: white;">
            <img :src="qrLink" style="height: 20mm; width: 20mm;">
          </div>
        </div>

        <!-- Blue Line -->
        <div style="margin-bottom: 4mm;">
          <img src="assets/blue-line.png" style="width: 100%;">
        </div>

        <!-- Two Column Layout - Main Content Area -->
        <div style="display: flex; gap: 6mm; flex: 1;">

          <!-- Left Column -->
          <div style="flex: 1; display: flex; flex-direction: column; gap: 4mm;">
            <!-- Project Details Section -->
            <div style="flex: 1; display: flex; flex-direction: column;">
              <h3 style="margin: 0 0 3mm 0; padding: 2mm 3mm; background: #e2f2fd; font-size: 11px; color: #0045a1; text-transform: uppercase; border-left: 3px solid #0045a1;">
                Project Information
              </h3>
              <table style="width: 100%; font-size: 10px; border-collapse: collapse; flex: 1;">
                <tr>
                  <td style="padding: 2.5mm; width: 35%; color: #666; border-bottom: 1px solid #eee;">Project Title:</td>
                  <td style="padding: 2.5mm; font-weight: 600; border-bottom: 1px solid #eee;">{{ applicationData.project_title }}</td>
                </tr>
                <tr>
                  <td style="padding: 2.5mm; color: #666; border-bottom: 1px solid #eee;">Development Type:</td>
                  <td style="padding: 2.5mm; font-weight: 600; border-bottom: 1px solid #eee;">{{ formatDevelopmentType(applicationData.development_type) }}</td>
                </tr>
                <tr>
                  <td style="padding: 2.5mm; color: #666; border-bottom: 1px solid #eee;">Ownership Type:</td>
                  <td style="padding: 2.5mm; font-weight: 600; border-bottom: 1px solid #eee;">{{ applicationData.ownership_type || '-' }}</td>
                </tr>
                <tr>
                  <td style="padding: 2.5mm; color: #666; border-bottom: 1px solid #eee;">Estimated Value:</td>
                  <td style="padding: 2.5mm; font-weight: 600; border-bottom: 1px solid #eee;">KES {{ numberFormat(applicationData.project_value || 0) }}</td>
                </tr>
                <tr>
                  <td style="padding: 2.5mm; color: #666; vertical-align: top;">Description:</td>
                  <td style="padding: 2.5mm; font-weight: 400; line-height: 1.4;">{{ truncateText(applicationData.project_description, 120) }}</td>
                </tr>
              </table>
            </div>

            <!-- Property Details Section -->
            <div style="flex: 1; display: flex; flex-direction: column;">
              <h3 style="margin: 0 0 3mm 0; padding: 2mm 3mm; background: #e2f2fd; font-size: 11px; color: #0045a1; text-transform: uppercase; border-left: 3px solid #0045a1;">
                Property Details
              </h3>
              <table style="width: 100%; font-size: 10px; border-collapse: collapse; flex: 1;">
                <tr>
                  <td style="padding: 2.5mm; width: 35%; color: #666; border-bottom: 1px solid #eee;">LR Number:</td>
                  <td style="padding: 2.5mm; font-weight: 600; border-bottom: 1px solid #eee;">{{ applicationData.plot_number || '-' }}</td>
                </tr>
                <tr>
                  <td style="padding: 2.5mm; color: #666; border-bottom: 1px solid #eee;">Property Owner:</td>
                  <td style="padding: 2.5mm; font-weight: 600; border-bottom: 1px solid #eee;">{{ truncateText(applicationData.owner_full_names, 40) || '-' }}</td>
                </tr>
                <tr>
                  <td style="padding: 2.5mm; color: #666; border-bottom: 1px solid #eee;">Location:</td>
                  <td style="padding: 2.5mm; font-weight: 600; border-bottom: 1px solid #eee;">{{ applicationData.subCountyName || '-' }} {{ applicationData.wardName ? '- ' + applicationData.wardName : '' }}</td>
                </tr>
                <tr>
                  <td style="padding: 2.5mm; color: #666;">Address:</td>
                  <td style="padding: 2.5mm; font-weight: 600;">{{ applicationData.owner_address || '-' }}</td>
                </tr>
              </table>
            </div>
          </div>

          <!-- Right Column -->
          <div style="flex: 1; display: flex; flex-direction: column; gap: 4mm;">
            <!-- Professional Details Section -->
            <div>
              <h3 style="margin: 0 0 3mm 0; padding: 2mm 3mm; background: #e2f2fd; font-size: 11px; color: #0045a1; text-transform: uppercase; border-left: 3px solid #0045a1;">
                Professional Details
              </h3>
              <table style="width: 100%; font-size: 10px; border-collapse: collapse;">
                <tr>
                  <td style="padding: 2.5mm; width: 40%; color: #666; border-bottom: 1px solid #eee;">Professional Name:</td>
                  <td style="padding: 2.5mm; font-weight: 600; border-bottom: 1px solid #eee;">{{ applicationData.professional_name || '-' }}</td>
                </tr>
                <tr>
                  <td style="padding: 2.5mm; color: #666;">Professional Type:</td>
                  <td style="padding: 2.5mm; font-weight: 600;">{{ formatProfessionalType(applicationData.professional_type) }}</td>
                </tr>
              </table>
            </div>

            <!-- Submitted By Section -->
            <div>
              <h3 style="margin: 0 0 3mm 0; padding: 2mm 3mm; background: #e2f2fd; font-size: 11px; color: #0045a1; text-transform: uppercase; border-left: 3px solid #0045a1;">
                Submitted By
              </h3>
              <table style="width: 100%; font-size: 10px; border-collapse: collapse;">
                <tr>
                  <td style="padding: 2.5mm; width: 40%; color: #666; border-bottom: 1px solid #eee;">Name:</td>
                  <td style="padding: 2.5mm; font-weight: 600; border-bottom: 1px solid #eee;">{{ applicationData.created_by || '-' }}</td>
                </tr>
                <tr>
                  <td style="padding: 2.5mm; color: #666;">ID Number:</td>
                  <td style="padding: 2.5mm; font-weight: 600;">{{ applicationData.created_by_id || '-' }}</td>
                </tr>
              </table>
            </div>

            <!-- Important Notice -->
            <div style="flex: 1; background: #fff3cd; padding: 4mm; border-radius: 2mm; border-left: 3px solid #ffc107;">
              <h4 style="margin: 0 0 2mm 0; font-size: 11px; color: #856404; text-transform: uppercase;">⚠️ Important Notice</h4>
              <ul style="margin: 0; padding: 0 0 0 4mm; font-size: 10px; line-height: 1.6; color: #333;">
                <li>This acknowledges your application has been received.</li>
                <li style="color: #dc3545; font-weight: 600;">This is NOT a payment receipt.</li>
                <li>Payment must be made at the Cashier Office.</li>
                <li>Scan QR code to track your application status.</li>
                <li>For inquiries, quote: <strong>{{ applicationData.application_number }}</strong></li>
              </ul>
            </div>

            <!-- Signature Area -->
            <div style="margin-top: auto; padding-top: 4mm;">
              <div style="border-top: 1px solid #333; width: 60%; margin-left: auto; padding-top: 2mm; text-align: center;">
                <p style="margin: 0; font-size: 9px; color: #666;">Authorized Signature & Stamp</p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Footer Section -->
      <div style="padding: 5mm 10mm; background-color: #e2f2fd;">

        <!-- Cashier Office Notice -->
        <div style="background: white; padding: 4mm; border-radius: 2mm; margin-bottom: 4mm; border: 2px solid #dc3545; display: flex; justify-content: space-between; align-items: center;">
          <div>
            <h4 style="margin: 0 0 1mm 0; font-size: 12px; color: #dc3545; text-transform: uppercase; font-weight: 700;">⚠️ Payment Required</h4>
            <p style="margin: 0; padding: 0; font-size: 10px; line-height: 1.5; color: #333;">
              Please visit the <strong>Cashier Office</strong> at the County Headquarters to complete your payment and proceed with your application.
            </p>
          </div>
          <div style="text-align: center; padding-left: 6mm; border-left: 1px solid #ddd; margin-left: 4mm;">
            <p style="margin: 0; font-size: 9px; color: #666;">Bill Number</p>
            <p style="margin: 1mm 0 0 0; font-size: 14px; font-weight: 700; color: #0045a1;">{{ applicationData.billNo || '-' }}</p>
          </div>
        </div>

        <!-- Contact Info -->
        <div style="display: flex; justify-content: space-between; align-items: center; font-size: 9px; color: #666;">
          <div>
            <p style="margin: 0; padding: 0;">For inquiries: {{ county.email }} | Portal: {{ county.selfService }}</p>
            <p style="margin: 1mm 0 0 0; padding: 0;">Printed on: {{ getCurrentDateTime() }}</p>
          </div>
          <div style="text-align: right;">
            <p style="margin: 0; font-size: 8px; color: #999;">{{ county.powered || 'Powered by County Government' }}</p>
          </div>
        </div>

      </div>

    </page>
  </div>

  </body>
</template>

<script>
/* eslint-disable */
import { execute, econstruction, authUrl } from "@/api";

export default {
  name: "ApplicationAcknowledgment",
  data() {
    return {
      loading: true,
      error: null,
      applicationNumber: '',
      applicationData: {},
      county: {
        countyName: '',
        address: '',
        email: '',
        selfService: '',
        powered: '',
        payBill: '',
        QRLink: 'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=',
        logo: '',
        stateLogo: ''
      },
      qrLink: ''
    };
  },
  mounted() {
    // Get the hash from the URL - check if application number is passed in URL
    const hash = window.location.hash;
    const parts = hash.split('/');
    const numberFromURL = parts[2]; // e.g., /#/application-acknowledgment/ECON-20260121-D1B860

    if (numberFromURL && numberFromURL !== 'application-acknowledgment') {
      // Application number passed in URL
      console.log('Application number from URL:', numberFromURL);
      this.applicationNumber = numberFromURL;
      this.getCounty();
      this.getApplication();
    } else {
      // Check localStorage
      try {
        const params = JSON.parse(localStorage.getItem('applicationReceipt'));
        if (params && params.applicationNumber) {
          this.applicationNumber = params.applicationNumber;
          this.getCounty();
          this.getApplication();
        } else {
          this.loading = false;
          this.error = 'Invalid application data. Please try again.';
        }
      } catch (error) {
        this.loading = false;
        this.error = 'Invalid application data. Please try again.';
        console.error('Error loading application data:', error);
      }
    }
  },
  methods: {
    county_logo() {
      return this.county.logo || 'assets/logo/county_logo.png';
    },
    state_logo() {
      return this.county.stateLogo || 'assets/logo/state_logo.png';
    },

    async getCounty() {
      try {
        const data = new FormData();
        data.append("function", "getCounty");
        const res = await execute(data, authUrl);
        if (res.data.success) {
          this.county = { ...this.county, ...res.data.data.county };
        }
      } catch (error) {
        console.error('Error fetching county data:', error);
      }
    },

    async getApplication() {
      try {
        const data = new FormData();
        data.append("function", "getApplications");
        data.append("search", this.applicationNumber);
        data.append("page", "1");
        data.append("rows_per_page", "1");

        const res = await execute(data, econstruction);
        if (res.data.success && res.data.data?.applications?.length > 0) {
          this.applicationData = res.data.data.applications[0];
          this.generateQRCode();
          this.loading = false;
        } else {
          this.error = 'Application not found. Please check the application number.';
          this.loading = false;
        }
      } catch (e) {
        this.error = 'Failed to load application: ' + e.message;
        this.loading = false;
        console.error('Error fetching application:', e);
      }
    },

    generateQRCode() {
      // QR code links to track-application page with the application number
      // Example: https://selfservice.county.go.ke/#/track-application/ECON-20260121-D1B860
      const trackingUrl = this.county.selfService + "/#/track-application/" + this.applicationData.application_number;
      this.qrLink = "https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=" + encodeURIComponent(trackingUrl);
    },

    getCurrentDateTime() {
      const now = new Date();
      return now.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
      });
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      });
    },

    numberFormat(num) {
      return new Intl.NumberFormat("en-GB").format(num);
    },

    truncateText(text, maxLength) {
      if (!text) return '-';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },

    getStatusStyle(status) {
      const styles = {
        'pending': 'background: #fff3cd; color: #856404; padding: 1mm 3mm; border-radius: 1mm; font-size: 9px; font-weight: 600;',
        'approved': 'background: #d4edda; color: #155724; padding: 1mm 3mm; border-radius: 1mm; font-size: 9px; font-weight: 600;',
        'rejected': 'background: #f8d7da; color: #721c24; padding: 1mm 3mm; border-radius: 1mm; font-size: 9px; font-weight: 600;',
        'in_progress': 'background: #cce5ff; color: #004085; padding: 1mm 3mm; border-radius: 1mm; font-size: 9px; font-weight: 600;',
        'under_review': 'background: #e2e3e5; color: #383d41; padding: 1mm 3mm; border-radius: 1mm; font-size: 9px; font-weight: 600;'
      };
      return styles[status?.toLowerCase()] || styles['pending'];
    },

    formatDevelopmentType(type) {
      const types = {
        'residential': 'Residential',
        'commercial': 'Commercial',
        'industrial': 'Industrial',
        'institutional': 'Institutional',
        'subdivision': 'Subdivision/Amalgamation of land',
        'landUseChange': 'Change/Extension of Use of land',
        'leaseRenewal': 'Extension/Renewal of Lease',
        'advertising': 'Outdoor Advertising & Signage',
        'regularisation': 'Regularisation of Existing Developments',
        'structuralEngineering': 'Structural Engineering Designs & Supervision',
        'civilEngineering': 'Civil Engineering Designs, Works & Clearing',
        'newBuildings': 'New Buildings',
        'buildingAlterations': 'Alterations and Additions to Existing Buildings',
        'demolition': 'Demolition of Dwellings',
        'architecturalRegularisation': 'Architectural Regularisation'
      };
      return types[type] || type || '-';
    },

    formatProfessionalType(type) {
      const types = {
        'architect': 'Architect',
        'civilEngineer': 'Civil Engineer',
        'structuralEngineer': 'Structural Engineer',
        'electricalEngineer': 'Electrical Engineer',
        'mechanicalEngineer': 'Mechanical Engineer',
        'landSurveyor': 'Land Surveyor',
        'urbanPlanner': 'Urban Planner'
      };
      return types[type] || type || '-';
    },

    goBack() {
      window.history.back();
    }
  }
};
</script>

<style>
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media print {
  body {
    background-color: white !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .print-btn {
    display: none !important;
  }
  .page {
    margin: 0 !important;
    box-shadow: none !important;
  }
}

@media screen {
  .page {
    box-shadow: 0 0 10px rgba(0,0,0,0.1);
    margin: 10mm auto;
  }
}

.print-btn {
  position: fixed;
  right: 20px;
  top: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #0045a1;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  z-index: 1000;
  transition: transform 0.2s, box-shadow 0.2s;
}

.print-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0,0,0,0.3);
}

.print-btn img {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}
</style>